import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getEvents, isLoading } from './app/selectors';
import { AppActions } from './app/slice';
import GalleryCard from './components/GalleryCard';
import './GalleryPage.scss';

const AllVideosPage: React.FC = () => {
  const dispatch = useDispatch();
  const loading = useSelector(isLoading);
  const events = useSelector(getEvents);

  useEffect(() => {
    if (!loading) return;
    dispatch(AppActions.startApp());
  }, [dispatch, loading]);

  return (
    <div className="gallery-page">
      <h1>All videos</h1>
      {loading ? (
        <div className="gallery-loading">Loading...</div>
      ) : (
        <div className="gallery-content">
          <div className="gallery-category">
            <div className="gallery-category__grid">
              {events.map((event) => (
                <a
                  href="https://neuronation-med.de/cme/supporting-patients-with-mci"
                  target="_top"
                  aria-label={`View course: ${event.title}`}>
                  <GalleryCard
                    key={event.id}
                    heading={event.title}
                    categories={event.categories}
                    authorName={event.presenterName}
                    authorTitle={event.presenterDescription}
                    authorImage={event.presenterImageURL}
                  />
                </a>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AllVideosPage;
